import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: joshua-maros
 * id 81421142-BE10-4918-8720-5858B7BC2E4B
 * name eye-closed
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-closed.svg
 * tags
 */
export const EyeClosedIcon = createSvgIcon(<><path d="M12 17.5C8.2 17.5 4.8 15.4 3.2 12H1C2.7 16.4 7 19.5 12 19.5S21.3 16.4 23 12H20.8C19.2 15.4 15.8 17.5 12 17.5Z" /></>, 'EyeClosedIcon');
export default EyeClosedIcon